import React, { ErrorInfo, ReactNode } from "react";
import { Box, Button, Container, Paper, Typography } from "@mui/material";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[ErrorBoundary] A render error was caught and a blank screen was prevented.", error, errorInfo);
  }

  public render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: "center" }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Algo deu errado
          </Typography>
          <Typography color="text.secondary" mb={3}>
            Ocorreu um erro inesperado. Atualize a página para tentar novamente.
          </Typography>
          <Box display="flex" justifyContent="center" gap={2}>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Atualizar página
            </Button>
            <Button variant="outlined" href="/">
              Ir para o início
            </Button>
          </Box>
        </Paper>
      </Container>
    );
  }
}
